export default function (instance) {
  return {
    country() {
      return instance.post("country", {});
    },
    oblast(payload) {
      return instance.post("oblast", { id_country: payload.id_country });
    },
    rayon(payload) {
      return instance.post("rayon", { id_oblast: payload.id_oblast });
    },
    mektep(payload) {
      return instance.post("mektep", { id_rayon: payload.id_rayon });
    },
  };
}
